(<template>
  <div class="apply-actions">
    <sk-checkbox v-if="isSameSupplierSeriesJob"
                 :item-text="seriesJobConfirmationText"
                 :preselected-value="seriesJobConfirmation"
                 :validation-name="seriesJobConfirmationValidationName"
                 class="apply-actions__checkbox"
                 @checkboxvaluechanged="setSeriesJobConfirmation" />
    <div class="apply-actions__wrapper">
      <div class="apply-actions__button-wrapper">
        <div class="apply-actions__actions-cont">
          <slot name="applyButton"></slot>
          <button v-if="canAbandon"
                  class="sk-btn sk-btn--white apply-actions__decline-btn"
                  @click="handleAbandon">{{ $gettext('Decline') }}</button>
        </div>
        <a v-if="supportPortalLink"
           :href="supportPortalLink"
           class="apply-actions__redirect-link"
           target="_blank">{{ $gettext('Frequently asked questions') }}</a>
      </div>
      <p v-if="helpArticleLink"
         class="apply-actions__help-link"
         v-html="helpArticleText"></p>
    </div>
  </div>
</template>)

<script>
  import ApplyPrototype from '@/prototypes/one_assignment_page/ApplyPrototype';

  export default {
    extends: ApplyPrototype
  };
</script>

<style>
  .apply-actions__highlighted-text {
    color: var(--color-primary);
    font-weight: bold;
  }
</style>

<style scoped>
.apply-actions {
  margin-top: 30px;
}

.apply-actions__wrapper {
  display: flex;
}

.apply-actions__checkbox {
  margin-bottom: 30px;
}

.apply-actions__button-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 0;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.apply-actions__actions-cont {
  display: flex;
}

.apply-actions__decline-btn {
  flex-shrink: 0;
  width: auto;
  margin-left: 15px;
  padding: 0 15px;
}

.apply-actions__redirect-link {
  padding-left: 26px;
  background-image: url(~@assets/imgs/undefined_imgs/chat_alternative_icon.svg);
  background-repeat: no-repeat;
}

.apply-actions__help-link {
  order: 1;
  margin-left: 40px;
  font-size: 12px;
}

@media (max-width: 767px) {
  .apply-actions__wrapper {
    flex-wrap: wrap;
  }

  .apply-actions__help-link {
    order: 0;
    margin-bottom: 20px;
    margin-left: 0;
    font-size: 12px;
  }
}

@media (max-width: 525px) {
  .apply-actions__actions-cont {
    width: 100%;
  }

  .apply-actions__redirect-link {
    margin: 0 auto;
  }
}
</style>
